export default __webpack_public_path__ + "static/media/documents.b90bd8ba.svg";